import memoize from 'fast-memoize'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

// const getIsAdmin = () => pipe(getParamFromUrl, equals(`1`))(`is-admin`)

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// Create an object representing our environmental configuration
// Note that we are not using destructuring of `process.env` so that Webpack's
// define plugin (used by Webpack's DotEnv plugin) works correctly
const getEnvironment = memoize(() => {
  // If `is-admin` is supplied via a query string, set our origins and domains
  // to use the admin config. Temporarily disable it until we are ready.
  const isAdmin = false // getIsAdmin()

  const ORIGIN = isAdmin
    ? {
        APP: process.env.API_ORIGIN_RAILS_APP_ADMIN,
        AUTH_SERVICE: process.env.API_ORIGIN_AUTH_SERVICE_ADMIN,
      }
    : {
        APP: process.env.API_ORIGIN_RAILS_APP,
        AUTH_SERVICE: process.env.API_ORIGIN_AUTH_SERVICE,
      }

  const HOST = isAdmin
    ? {
        APP: process.env.HOST_APP_ADMIN,
      }
    : {
        APP: process.env.HOST_APP,
      }

  return {
    ORIGIN,
    HOST,
  }
})

export default getEnvironment
